<div class="reports-container">
    <!-- Header Section -->
    <div class="reports-header">
        <div class="header-content">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
            </div>
            <div class="header-text">
                <h1 class="page-title">Voucher Reports</h1>
                <p class="page-subtitle">Track and manage your issued vouchers</p>
            </div>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons" *ngIf="!isLoading && !errorMessage">
        <button class="btn-filter" (click)="toggleFilters()" [class.active]="showFilters">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
            <span class="btn-text">Filters</span>
            <span class="filter-badge" *ngIf="hasActiveFilters()">{{ hasActiveFilters() ? '●' : '' }}</span>
        </button>

        <button class="btn-export" (click)="exportToCSV()" [disabled]="vouchers.length === 0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span class="btn-text">Export CSV</span>
        </button>
    </div>

    <!-- Filter Panel -->
    <div class="filter-panel" *ngIf="showFilters" [@slideDown]>
        <div class="filter-header">
            <h3>Filter Vouchers</h3>
            <button class="btn-close-filters" (click)="toggleFilters()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="filter-grid">
            <div class="filter-group">
                <label for="customerName">Customer Name</label>
                <input type="text" id="customerName" [(ngModel)]="filters.customerName"
                    placeholder="Search by customer name" class="filter-input">
            </div>

            <div class="filter-group">
                <label for="phoneNumber">Phone Number</label>
                <input type="text" id="phoneNumber" [(ngModel)]="filters.phoneNumber"
                    placeholder="Search by phone number" class="filter-input">
            </div>

            <div class="filter-group">
                <label for="status">Status</label>
                <select id="status" [(ngModel)]="filters.status" class="filter-select">
                    <option [ngValue]="undefined">All Statuses</option>
                    <option [ngValue]="VoucherStatus.Active">Active</option>
                    <option [ngValue]="VoucherStatus.Redeemed">Redeemed</option>
                    <option [ngValue]="VoucherStatus.Expired">Expired</option>
                    <option [ngValue]="VoucherStatus.Cancelled">Cancelled</option>
                    <option [ngValue]="VoucherStatus.Revoked">Revoked</option>
                </select>
            </div>

            <div class="filter-group">
                <label for="minAmount">Min Amount</label>
                <input type="number" id="minAmount" [(ngModel)]="filters.minVoucherAmount" placeholder="Min ₹"
                    class="filter-input" min="0">
            </div>

            <div class="filter-group">
                <label for="maxAmount">Max Amount</label>
                <input type="number" id="maxAmount" [(ngModel)]="filters.maxVoucherAmount" placeholder="Max ₹"
                    class="filter-input" min="0">
            </div>

            <div class="filter-group">
                <label for="redemptionReference">Redemption Reference</label>
                <input type="text" id="redemptionReference" [(ngModel)]="filters.redemptionReference"
                    placeholder="Search by reference" class="filter-input">
            </div>

            <div class="filter-group">
                <label for="fromDate">From Date</label>
                <input type="date" id="fromDate" [(ngModel)]="filters.fromDate" class="filter-input">
            </div>

            <div class="filter-group">
                <label for="toDate">To Date</label>
                <input type="date" id="toDate" [(ngModel)]="filters.toDate" class="filter-input">
            </div>


        </div>

        <div class="filter-actions">
            <button class="btn-clear" (click)="clearFilters()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Clear Filters
            </button>
            <button class="btn-apply" (click)="applyFilters()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                Apply Filters
            </button>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-section" *ngIf="isLoading">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading vouchers...</p>
    </div>

    <!-- Error Message -->
    <div class="error-message" *ngIf="errorMessage && !isLoading">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>{{ errorMessage }}</span>
    </div>

    <!-- Vouchers Table -->
    <div class="vouchers-section" *ngIf="!isLoading && !errorMessage">
        <!-- Desktop Table View -->
        <div class="table-container desktop-only">
            <table class="vouchers-table" *ngIf="vouchers.length > 0">
                <thead>
                    <tr>
                        <th>Voucher Code</th>
                        <th>Customer</th>
                        <th>Phone</th>
                        <th>Voucher Amount</th>
                        <th>Min Purchase</th>
                        <th>Outlet</th>
                        <th>Status</th>
                        <th>Redemption Ref</th>
                        <th>Expiry</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let voucher of vouchers">
                        <tr [class]="getStatusClass(voucher.status)" [class.expanded-row]="isExpanded(voucher.id!)"
                            (click)="toggleVoucherDetails(voucher.id!)">
                            <td class="voucher-code">{{ voucher.voucherCode }}</td>
                            <td class="customer-name">{{ voucher.customerName }}</td>
                            <td class="phone-number">{{ voucher.customerPhoneNumber }}</td>
                            <td class="amount">₹{{ voucher.voucherAmount | number:'1.2-2' }}</td>
                            <td class="amount">₹{{ voucher.minimumPurchaseAmount | number:'1.2-2' }}</td>
                            <td class="outlet-name">{{ voucher.outletName || '-' }}</td>
                            <td>
                                <span class="status-badge" [ngClass]="getStatusClass(voucher.status)">
                                    {{ getStatusLabel(voucher.status) }}
                                </span>
                            </td>
                            <td class="redemption-ref">{{ voucher.redemptionReference || '-' }}</td>
                            <td class="expiry-date">{{ formatDate(voucher.expiryDate) }}</td>
                            <td>
                                <button class="btn-toggle"
                                    (click)="$event.stopPropagation(); toggleVoucherDetails(voucher.id!)">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor" [class.rotate-180]="isExpanded(voucher.id!)">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7" />
                                    </svg>
                                </button>
                            </td>
                        </tr>
                        <!-- Expanded Details Row -->
                        <tr *ngIf="isExpanded(voucher.id!)" class="details-row" [@slideDown]>
                            <td colspan="10">
                                <div class="details-container">
                                    <div class="details-grid">
                                        <!-- Voucher Information -->
                                        <div class="detail-section">
                                            <h4>Voucher Information</h4>
                                            <div class="detail-items">
                                                <div class="detail-item">
                                                    <span class="detail-label">Voucher Code:</span>
                                                    <span class="detail-value code">{{ voucher.voucherCode }}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Config Name:</span>
                                                    <span class="detail-value">{{ voucher.voucherConfigName || 'N/A'
                                                        }}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Status:</span>
                                                    <span class="status-badge"
                                                        [ngClass]="getStatusClass(voucher.status)">
                                                        {{ getStatusLabel(voucher.status) }}
                                                    </span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Voucher Amount:</span>
                                                    <span class="detail-value amount">₹{{ voucher.voucherAmount |
                                                        number:'1.2-2' }}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Min Purchase Amount:</span>
                                                    <span class="detail-value amount">₹{{ voucher.minimumPurchaseAmount
                                                        |
                                                        number:'1.2-2' }}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Expiry Date:</span>
                                                    <span class="detail-value">{{ formatDate(voucher.expiryDate)
                                                        }}</span>
                                                </div>
                                                <div class="detail-item" *ngIf="voucher.outletName">
                                                    <span class="detail-label">Outlet:</span>
                                                    <span class="detail-value">{{ voucher.outletName }}</span>
                                                </div>
                                                <div class="detail-item" *ngIf="voucher.redemptionReference">
                                                    <span class="detail-label">Redemption Reference:</span>
                                                    <span class="detail-value">{{ voucher.redemptionReference }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Customer Information -->
                                        <div class="detail-section">
                                            <h4>Customer Information</h4>
                                            <div class="detail-items">
                                                <div class="detail-item">
                                                    <span class="detail-label">Name:</span>
                                                    <span class="detail-value">{{ voucher.customerName }}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Phone:</span>
                                                    <span class="detail-value">{{ voucher.customerPhoneNumber
                                                        }}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="detail-label">Customer ID:</span>
                                                    <span class="detail-value">{{ voucher.customerId }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Redemption Information (if redeemed) -->
                                        <div class="detail-section" *ngIf="voucher.status === VoucherStatus.Redeemed">
                                            <h4>Redemption Information</h4>
                                            <div class="detail-items">
                                                <div class="detail-item" *ngIf="voucher.redeemedAt">
                                                    <span class="detail-label">Redeemed At:</span>
                                                    <span class="detail-value">{{ formatDateTime(voucher.redeemedAt)
                                                        }}</span>
                                                </div>
                                                <div class="detail-item" *ngIf="voucher.redemptionReference">
                                                    <span class="detail-label">Reference:</span>
                                                    <span class="detail-value">{{ voucher.redemptionReference
                                                        }}</span>
                                                </div>
                                                <div class="detail-item full-width" *ngIf="voucher.notes">
                                                    <span class="detail-label">Notes:</span>
                                                    <span class="detail-value">{{ voucher.notes }}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <!-- Mobile Card View -->
        <div class="vouchers-cards mobile-only" *ngIf="vouchers.length > 0">
            <div class="voucher-card" *ngFor="let voucher of vouchers" [class.expanded]="isExpanded(voucher.id!)">
                <div class="card-header" (click)="toggleVoucherDetails(voucher.id!)">
                    <span class="voucher-code">{{ voucher.voucherCode }}</span>
                    <div class="header-right">
                        <span class="status-badge" [ngClass]="getStatusClass(voucher.status)">
                            {{ getStatusLabel(voucher.status) }}
                        </span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                            class="expand-icon" [class.rotate-180]="isExpanded(voucher.id!)">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>

                <div class="card-body">
                    <div class="card-row">
                        <span class="label">Customer:</span>
                        <span class="value">{{ voucher.customerName }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">Phone:</span>
                        <span class="value">{{ voucher.customerPhoneNumber }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">Amount:</span>
                        <span class="value amount">₹{{ voucher.voucherAmount | number:'1.2-2' }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">Min Purchase:</span>
                        <span class="value amount">₹{{ voucher.minimumPurchaseAmount | number:'1.2-2' }}</span>
                    </div>
                    <div class="card-row" *ngIf="voucher.outletName">
                        <span class="label">Outlet:</span>
                        <span class="value">{{ voucher.outletName }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">Expiry:</span>
                        <span class="value">{{ formatDate(voucher.expiryDate) }}</span>
                    </div>
                </div>

                <!-- Expanded Details in Card -->
                <div class="card-details" *ngIf="isExpanded(voucher.id!)" [@slideDown]>
                    <div class="detail-section">
                        <h4>Additional Details</h4>
                        <div class="detail-items">
                            <div class="detail-item">
                                <span class="detail-label">Config Name:</span>
                                <span class="detail-value">{{ voucher.voucherConfigName || 'N/A' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">Min Purchase Amount:</span>
                                <span class="detail-value amount">₹{{ voucher.minimumPurchaseAmount | number:'1.2-2'
                                    }}</span>
                            </div>
                            <div class="detail-item" *ngIf="voucher.outletName">
                                <span class="detail-label">Outlet:</span>
                                <span class="detail-value">{{ voucher.outletName }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">Customer ID:</span>
                                <span class="detail-value">{{ voucher.customerId }}</span>
                            </div>
                            <div class="detail-item" *ngIf="voucher.redemptionReference">
                                <span class="detail-label">Redemption Reference:</span>
                                <span class="detail-value">{{ voucher.redemptionReference }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section" *ngIf="voucher.status === VoucherStatus.Redeemed">
                        <h4>Redemption Info</h4>
                        <div class="detail-items">
                            <div class="detail-item" *ngIf="voucher.redeemedAt">
                                <span class="detail-label">Redeemed At:</span>
                                <span class="detail-value">{{ formatDateTime(voucher.redeemedAt) }}</span>
                            </div>
                            <div class="detail-item" *ngIf="voucher.redemptionReference">
                                <span class="detail-label">Reference:</span>
                                <span class="detail-value">{{ voucher.redemptionReference }}</span>
                            </div>
                            <div class="detail-item full-width" *ngIf="voucher.notes">
                                <span class="detail-label">Notes:</span>
                                <span class="detail-value">{{ voucher.notes }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination-container" *ngIf="!isLoading && !errorMessage && vouchers.length > 0">
        <div class="pagination-info">
            <p>Showing {{ (currentPage - 1) * filters.pageSize! + 1 }} to {{ Math.min(currentPage * filters.pageSize!,
                totalCount) }} of {{ totalCount }} vouchers</p>
            <div class="page-size-selector">
                <label for="pageSizeSelect">Items per page:</label>
                <select id="pageSizeSelect" [(ngModel)]="filters.pageSize" (ngModelChange)="onPageSizeChange($event)" class="page-size-dropdown">
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="20">20</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                </select>
            </div>
        </div>
        <div class="pagination-controls">
            <button class="btn-page" (click)="previousPage()" [disabled]="currentPage === 1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
                <span class="btn-text">Previous</span>
            </button>

            <div class="page-numbers">
                <button *ngFor="let page of getPageNumbers()" class="btn-page-number"
                    [class.active]="page === currentPage" (click)="goToPage(page)">
                    {{ page }}
                </button>
            </div>

            <button class="btn-page" (click)="nextPage()" [disabled]="currentPage === totalPages">
                <span class="btn-text">Next</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="vouchers.length === 0">
        <div class="empty-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
        </div>
        <h3>No Vouchers Found</h3>
        <p>{{ hasActiveFilters() ? 'Try adjusting your filters' : 'No vouchers have been issued yet' }}</p>
        <button class="btn-clear-filters" *ngIf="hasActiveFilters()" (click)="clearFilters()">
            Clear Filters
        </button>
    </div>
</div>